// El texto que una pantalla muestra ante un error de la API. Un 5xx llega
// enmascarado por core-api («Something went wrong») y un corte de red
// trae el texto del navegador («Failed to fetch»): ninguno sirve a un
// usuario en español, así que en esos casos va el mensaje propio de la
// pantalla. Un 4xx sí trae el motivo de dominio, en español, y se
// muestra tal cual.

import { ApiError } from "./error";

/** ¿El error dice algo propio (4xx con motivo) o es una falla de
 *  transporte / servidor / respuesta ilegible, en la que el cliente no
 *  sabe qué pasó del otro lado? */
export function esFallaIncierta(err: unknown): boolean {
  return !(err instanceof ApiError) || err.status === 0 || err.status >= 500;
}

export function mensajeDeError(err: unknown, fallback: string): string {
  return err instanceof ApiError && !esFallaIncierta(err) ? err.message : fallback;
}
